import React from 'react';
import {
  CardWrapper,
  HeadingWrapper,
} from 'admin/components/wrappers';
import styled from 'styled-components';
import { BackNumberCell } from './Cells/BackNumberCell';
import { RiderNameCell } from './Cells/RiderNameCell';
import { TeamNameCell } from './Cells/TeamNameCell';
import { CommonCell } from './Cells/CommonCell';
import { PositionCell } from './Cells/PositionCell';
import { MultipleDataGrid } from 'app/components/MultipleDataGrid/Index';
import {
  ElementaryPoints,
  HighSchoolTeam,
  SeniorJuniorHighPoint,
} from 'services/openapi';
import { TableSkeletonLoader } from 'app/components/TableSkeletonLoader';
import { BackNumberCellElem } from '../ElementaryPage/Cells/BackNumberCell';
import { RiderNameCellElem } from '../ElementaryPage/Cells/RiderNameCell';
import { TeamNameCellElem } from '../ElementaryPage/Cells/TeamNameCell';
import { TitleCardWrapper } from '../ScoreBoardPage';
import { PageMainLabel } from 'app/components/SHLabel';
import YedaLogo from 'app/components/admin/sidebar/assets/img/yeda-logo.png';

type Props = {
  highPointList: HighSchoolTeam | undefined;
  loading: boolean;
  showElementaryHighPointList: ElementaryPoints | undefined;
};
export const HighPointPrJrPage = ({
  highPointList,
  loading,
  showElementaryHighPointList,
}: Props) => {
  const srElementaryPearlRiderCells = [
    {
      field: 'name',
      title: 'Back#',
      cell: e => <BackNumberCell e={e} />,
      width: '50',
    },
    {
      field: 'teamName',
      title: 'Rider Name',
      cell: e => <RiderNameCell e={e} />,
      width: '150',
    },
    {
      field: 'teamId',
      title: 'Team',
      cell: e => <TeamNameCell e={e} />,
      width: '200',
    },
    {
      field: 'name',
      title: 'Ranch Riding',
      cell: e => <CommonCell
        value={
          e.dataItem.ranchRiding === 0 ||
            e.dataItem.ranchRiding === '' ||
            e.dataItem.ranchRiding === null
            ? "-"
            : e.dataItem.ranchRiding
        } />,
      width: '100',
    },
  ];
  const srRankCells = [
    {
      field: 'name',
      title: 'Pattern Hoursemanship',
      cell: e => <CommonCell
        value={
          e.dataItem.horsemanship === 0 ||
            e.dataItem.horsemanship === '' ||
            e.dataItem.horsemanship === null
            ? "-"
            : e.dataItem.horsemanship
        } />,
      width: '100',
    },
    {
      field: 'name',
      title: 'Sum',
      cell: e => <CommonCell
        value={
          e.dataItem.sum === 0 ||
            e.dataItem.sum === '' ||
            e.dataItem.sum === null
            ? "-"
            : e.dataItem.sum
        } />,
      width: '40',
    },
    {
      field: 'name',
      title: 'Rank',
      cell: e => (
        <CommonCell
          value={
            e.dataItem.rank === 0 ||
              e.dataItem.rank === '' ||
              e.dataItem.rank === null
              ? "-"
              : e.dataItem.rank
          } />
      ),
      width: '60',
    },
  ];
  const srPosition = {
    field: 'name',
    title: 'Position',
    cell: e => <PositionCell e={e} />,
    width: '150',
  };
  const jrElementaryPearlRiderCells = [
    {
      field: 'name',
      title: 'Back#',
      cell: e => <BackNumberCell e={e} />,
      width: '50',
    },
    {
      field: 'teamName',
      title: 'Rider Name',
      cell: e => <RiderNameCell e={e} />,
      width: '150',
    },
    {
      field: 'teamId',
      title: 'Team',
      cell: e => <TeamNameCell e={e} />,
      width: '200',
    },
    {
      field: 'name',
      title: 'Reining',
      cell: e => <CommonCell value={e.dataItem.reining} />,
      width: '100',
    },
  ];
  const jrRankCells = [
    {
      field: 'name',
      title: 'Pattern Hoursemanship',
      cell: e => <CommonCell
        value={
          e.dataItem.horsemanship === 0 ||
            e.dataItem.horsemanship === '' ||
            e.dataItem.horsemanship === null
            ? "-"
            : e.dataItem.horsemanship
        } />,
      width: '100',
    },
    {
      field: 'name',
      title: 'Sum',
      cell: e => <CommonCell
        value={
          e.dataItem.sum === 0 ||
            e.dataItem.sum === '' ||
            e.dataItem.sum === null
            ? "-" : e.dataItem.sum
        } />,
      width: '40',
    },
    {
      field: 'name',
      title: 'Rank',
      cell: e => (
        <CommonCell
          value={
            e.dataItem.sum === 0 ||
              e.dataItem.sum === '' ||
              e.dataItem.sum == null
              ? "-"
              : e.dataItem.rank
          } />
      ),
      width: '60',
    },
  ];
  const elementaryPearlRiderCells = [
    {
      field: 'name',
      title: 'Back#',
      cell: e => <BackNumberCellElem value={e?.dataItem?.riderBackNo} />,
      width: '50',
    },
    {
      field: 'teamName',
      title: 'Rider Name',
      cell: e => <RiderNameCellElem value={e?.dataItem?.riderName} />,
      width: '150',
    },
    {
      field: 'teamId',
      title: 'Team',
      cell: e => (
        <TeamNameCellElem
          value={e?.dataItem?.teamName}
          imageUrl={e?.dataItem?.teamImgUrl}
        />
      ),
      width: '200',
    },
    {
      field: '',
      title: 'Rail Hoursemanship',
      cell: e => <CommonCell
        value={
          e?.dataItem?.railHorsemanship === 0 ||
            e?.dataItem?.railHorsemanship === '' ||
            e?.dataItem?.railHorsemanship === null
            ? "-"
            : e?.dataItem?.railHorsemanship
        } />,
      width: '110',
    },
  ];
  const rankCells = [
    {
      field: '',
      title: 'Pattern Hoursemanship',
      cell: e => <CommonCell
        value={
          e?.dataItem?.patternHorsemanship === 0 ||
            e?.dataItem?.patternHorsemanship === '' ||
            e?.dataItem?.patternHorsemanship === null
            ? "-"
            : e?.dataItem?.patternHorsemanship
        } />,
      width: '120',
    },
    {
      field: '',
      title: 'Sum',
      cell: e => <CommonCell
        value={
          e?.dataItem?.sum === 0 ||
            e?.dataItem?.sum === '' ||
            e?.dataItem?.sum === null
            ? "-"
            : e?.dataItem?.sum
        } />,
      width: '50',
    },
    {
      field: '',
      title: 'Rank',
      cell: e => (
        <CommonCell
          value={
            e?.dataItem?.sum === 0 ||
              e?.dataItem?.sum === '' ||
              e?.dataItem?.sum === null
              ? "-"
              : e?.dataItem?.rank
          } />
      ),
      width: '50',
    },
  ];
  const jrPosition = {
    field: 'name',
    title: 'Position',
    cell: e => <PositionCell e={e} />,
    width: '150',
  };
  const position = {
    field: '',
    title: 'Position',
    cell: e => <PositionCell e={e} />,
    width: '150',
  };
  return (
    <>
      <ScreenOnlyWrapper>
        <CardWrapper style={{ paddingTop: '0px' }}>
          {loading ? (
            <TableSkeletonLoader rowContent={8} width={100} headingWidth={80} />
          ) : (
            <>
              <GridWrapper className="jr-rider-table">
                <TitleCardWrapper>
                  <HeadingWrapper className="heading-wrapper">
                    <PageMainLabel className="label-wrapper">
                      Sr Rider
                    </PageMainLabel>
                  </HeadingWrapper>
                </TitleCardWrapper>
                <MultipleDataGrid
                  showPagination={false}
                  data={highPointList?.seniorHighRiders!}
                  pageSize={4}
                  columns1={jrElementaryPearlRiderCells}
                  columns2={jrRankCells}
                  position={jrPosition}
                  isPosition
                  colomn1title={'SR Rider Information'}
                  colomn2title={'Rank'}
                />
              </GridWrapper>
              <GridWrapper className="sr-rider-table">
                <TitleCardWrapper>
                  <HeadingWrapper className="heading-wrapper">
                    <PageMainLabel className="label-wrapper">
                      Jr Rider
                    </PageMainLabel>
                  </HeadingWrapper>
                </TitleCardWrapper>
                <MultipleDataGrid
                  showPagination={false}
                  data={highPointList?.juniorHighRiders!}
                  pageSize={10}
                  columns1={srElementaryPearlRiderCells}
                  columns2={srRankCells}
                  position={srPosition}
                  isPosition
                  colomn1title={'JR Rider Information'}
                  colomn2title={'Rank'}
                />
              </GridWrapper>
              <GridWrapper>
                <TitleCardWrapper>
                  <HeadingWrapper className="heading-wrapper">
                    <PageMainLabel className="label-wrapper">
                      Elementary
                    </PageMainLabel>
                  </HeadingWrapper>
                </TitleCardWrapper>
                <MultipleDataGrid
                  data={showElementaryHighPointList!}
                  pageSize={10}
                  columns1={elementaryPearlRiderCells}
                  columns2={rankCells}
                  position={position}
                  isPosition
                  colomn1title={'Elementary Pearl Information'}
                  colomn2title={'Rank'}
                />
              </GridWrapper>
            </>
          )}
        </CardWrapper>
      </ScreenOnlyWrapper>
      <HighPointPrintTable
        highPointList={highPointList}
        showElementaryHighPointList={showElementaryHighPointList}
      />
    </>
  );
};

// ---------- Print-only components ----------

const SrJrPrintSection: React.FC<{
  title: string;
  data: SeniorJuniorHighPoint[] | null | undefined;
  col4Header: string;
  col4Field: 'reining' | 'ranchRiding';
}> = ({ title, data, col4Header, col4Field }) => (
  <>
    <tr className="section-title-row">
      <td colSpan={8}>{title}</td>
    </tr>
    <tr className="group-header-row">
      <th colSpan={4} className="section-header">
        {title} Information
      </th>
      <th colSpan={4} className="section-header">
        Rank
      </th>
    </tr>
    <tr className="col-header-row">
      <th>Back#</th>
      <th>Rider Name</th>
      <th>Team</th>
      <th>{col4Header}</th>
      <th>Pattern Horsemanship</th>
      <th>Sum</th>
      <th>Rank</th>
      <th>Position</th>
    </tr>
    {data?.map((rider, idx) => (
      <tr key={idx} className={idx % 2 === 1 ? 'row-alt' : ''}>
        <td>{rider.backNumber}</td>
        <td>{rider.riderName}</td>
        <td>{rider.teamName}</td>
        <td>{rider[col4Field] ?? ''}</td>
        <td>{rider.horsemanship ?? ''}</td>
        <td>{rider.sum ?? ''}</td>
        <td>{rider.sum === 0 ? '' : rider.rank ?? ''}</td>
        <td>
          {rider.rank === 1
            ? '1st'
            : rider.rank === 2
              ? '2nd'
              : rider.rank === 3
                ? '3rd'
                : ''}
        </td>
      </tr>
    ))}
  </>
);

const ElementaryPrintSection: React.FC<{
  data: ElementaryPoints | null | undefined;
}> = ({ data }) => {
  const rows = Array.isArray(data) ? data : data ? [data] : [];
  return (
    <>
      <tr className="section-title-row">
        <td colSpan={8}>Elementary</td>
      </tr>
      <tr className="group-header-row">
        <th colSpan={4} className="section-header">
          Elementary Pearl Information
        </th>
        <th colSpan={4} className="section-header">
          Rank
        </th>
      </tr>
      <tr className="col-header-row">
        <th>Back#</th>
        <th>Rider Name</th>
        <th>Team</th>
        <th>Rail Horsemanship</th>
        <th>Pattern Horsemanship</th>
        <th>Sum</th>
        <th>Rank</th>
        <th>Position</th>
      </tr>
      {rows.map((rider, idx) => (
        <tr key={idx} className={idx % 2 === 1 ? 'row-alt' : ''}>
          <td>{rider.riderBackNo}</td>
          <td>{rider.riderName}</td>
          <td>{rider.teamName}</td>
          <td>{rider.railHorsemanship ?? ''}</td>
          <td>{rider.patternHorsemanship ?? ''}</td>
          <td>{rider.sum ?? ''}</td>
          <td>{rider.sum === 0 ? '' : rider.rank ?? ''}</td>
          <td>
            {rider.rank === 1
              ? '1st'
              : rider.rank === 2
                ? '2nd'
                : rider.rank === 3
                  ? '3rd'
                  : ''}
          </td>
        </tr>
      ))}
    </>
  );
};

const HighPointPrintTable: React.FC<{
  highPointList: HighSchoolTeam | undefined;
  showElementaryHighPointList: ElementaryPoints | undefined;
}> = ({ highPointList, showElementaryHighPointList }) => (
  <PrintTableWrapper>
    <div className="print-logo">
      <img src={YedaLogo} alt="YEDA" />
    </div>
    <table className="print-table">
      <tbody>
        <SrJrPrintSection
          title="Sr Rider"
          data={highPointList?.seniorHighRiders}
          col4Header="Reining"
          col4Field="reining"
        />
        <SrJrPrintSection
          title="Jr Rider"
          data={highPointList?.juniorHighRiders}
          col4Header="Ranch Riding"
          col4Field="ranchRiding"
        />
        <ElementaryPrintSection data={showElementaryHighPointList} />
      </tbody>
    </table>
  </PrintTableWrapper>
);

// ---------- Styled Components ----------

const ScreenOnlyWrapper = styled.div`
  @media print {
    display: none;
  }
`;

const PrintTableWrapper = styled.div`
  display: none;
  @media print {
    display: block;
    width: 100%;
  }
  .print-logo {
    display: none;
    @media print {
      display: block;
      margin-bottom: 10px;
      img {
        width: 85px;
        height: auto;
      }
    }
  }
  .print-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 10px;
    font-family: 'Inter', Arial, sans-serif;
    color: #000;
    page-break-inside: auto;
  }
  .print-table th,
  .print-table td {
    border: 1px solid #ccc;
    padding: 3px 6px;
    text-align: left;
    vertical-align: middle;
  }
  .section-title-row td {
    background-color: #e7ecff;
    font-weight: 700;
    font-size: 12px;
    text-align: center;
    padding: 6px;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  .section-header {
    background-color: #d9e1f2;
    font-weight: 700;
    text-align: center;
    font-size: 11px;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  .col-header-row th {
    background-color: #eaecf0;
    font-weight: 600;
    text-align: center;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  .row-alt td {
    background-color: #f7f9fc;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  tr {
    page-break-inside: avoid;
  }
`;

const GridWrapper = styled.div`
  &.jr-rider-table {
    margin-bottom: 0px;
    tr[aria-rowindex='1'] {
      th[aria-colindex='8'] {
        padding-bottom: 34px;
      }
      .k-column-title {
        font-size: 14px;
        font-weight: 600;
        line-height: 14.52px;
        color: #000000;
      }
    }
    .k-grid-content {
      max-height: calc(68vh - 362px) !important;
    }
  }
  &.sr-rider-table {
    margin-bottom: 0px;
    tr[aria-rowindex='1'] {
      th[aria-colindex='8'] {
        padding-bottom: 34px;
      }
      .k-column-title {
        font-size: 14px;
        font-weight: 600;
        line-height: 14.52px;
        color: #000000;
      }
    }
    .k-grid-content {
      max-height: calc(68vh - 362px) !important;
    }
  }
  .k-grid-header tr th {
    border-top: 1px solid #eaecf0;
  }
  .k-grid-container .k-grid-content tr td:nth-last-child(1) {
    padding: 0px 24px 0px 0px !important;
  }

  .k-grid-content tr td.team-cell {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
  }
`;
